// Spanish translations — a complete map of every English key in
// resources.js, kept in the same order. Add a key here whenever one is added to en.
export const es = {
  add_remove_asset_pairs: "Agregar/quitar pares de trading",
  trading: "Pares de trading",
  tradingTitle: "Trading",
  edit: "Editar",
  title: "Título",
  try_to_refresh: "Intenta actualizar esta página.",
  refresh: "Actualizar",
  no_asset_configured: "No hay ningún activo configurado",
  contact_to_add_asset: "Contacta con soporte para agregar un nuevo activo",
  coin_address: "Dirección de la moneda",
  error_price_feed: "Error al conectar con el feed de precios",
  hide_filters: "Ocultar filtros",
  display_filters: "Mostrar filtros",
  hide_withdraw: "Ocultar panel de retiro",
  show_withdraw: "Mostrar panel de retiro",
  update_successful: "Actualización correcta",
  sucessfully_added_pair: "Agregaste un nuevo par correctamente",
  error_occured: "Se produjo un error",
  successfully_updated_pair: "Actualizaste correctamente el formulario para mostrar el par",
  filter_trades: "Filtrar operaciones",
  filter: "Filtrar",
  buy: "Comprar",
  sell: "Vender",
  buy_l: "comprar",
  sell_l: "vender",
  accept: "Aceptar",
  decline: "Rechazar",
  size_min: "Tamaño mín.",
  size_max: "Tamaño máx.",
  trade_id: "ID de operación",
  type: "Tipo",
  date_from: "Fecha desde",
  date_to: "Fecha hasta",
  trades_history: "Historial de operaciones",
  size: "Tamaño",
  search: "Buscar",
  trade_value: "Valor de la operación",
  price: "Precio",
  time: "Hora",
  add_new_pair: "Agregar nuevo par de trading",
  edit_trade_form: "Editar pares de trading",
  update_form: "Actualizar formulario",
  pair_shown: "Pares mostrados",
  close: "Cerrar",
  confirmation: "Confirmación",
  add_pair: "Agregar par",
  update_trade_settings: "Actualizar pares de trading",
  bad_request: "Solicitud incorrecta",
  request_result_error: "Tu solicitud produjo un error",
  back_to_homepage: "Volver al inicio",
  forbidden: "Acceso denegado",
  no_permission: "No tienes permiso para ver este recurso",
  was_not_found: "No se encontró la página que buscabas",
  address_mistyped: "Es posible que hayas escrito mal la dirección o que la página se haya movido",
  internal_server_error: "Error interno del servidor",
  service_unavailable: "Servicio no disponible",
  want_to_add_key: "¿Quieres agregar una nueva clave API para el cliente",
  adding_new_key: "Agregar nueva clave API",
  new_api_key: "Nueva clave API",
  generate_callback_secret: "Generar secreto de callback",
  cancel: "Cancelar",
  create_api_key: "Crear clave API",
  write_down_secret: "Anota el secreto de la nueva clave API",
  write_down_callbacl_secret: "Anota el nuevo secreto de callback",
  key: "Clave",
  secret: "Secreto",
  closing_api_key_window: "Después de cerrar esta ventana no podrás recuperar el secreto de la clave API",
  closing_callback_secret_window: "Después de cerrar esta ventana no podrás recuperar el secreto de callback",
  api_key_created: "Clave API creada",
  generated_callback_secret: "Secreto de callback generado",
  saved_secret: "Guardé el secreto de la clave API",
  saved_callback_secret: "Guardé el secreto de callback",
  api_keys: "Claves API",
  api_key_deleted: "Clave API eliminada",
  api_key_delete_success: "La clave API se eliminó correctamente",
  about_to_delete_key: "Estás a punto de eliminar la clave API",
  client: "Cliente",
  clients_summary: "Resumen de clientes",
  assets_summary: "Resumen de activos",
  supported_assets: "Activos compatibles",
  want_to_continue: "¿Quieres continuar?",
  deleting_api_key: "Eliminando clave API",
  delete_api_key: "Eliminar clave API",
  active_api_keys: "Claves API activas",
  delete: "Eliminar",
  assets: "Activos",
  trading_config: "Configuración de trading",
  primary: "Principal",
  secondary: "Secundario",
  min_trade: "Operación mín.",
  max_trade: "Operación máx.",
  assets_config: "Configuración de activos",
  code: "Código",
  deposits: "Depósitos",
  min_withdrawal: "Retiro mín.",
  withdrawal_fee: "Comisión de retiro",
  successfully_created_deposit_address: "Creaste una nueva dirección de depósito correctamente",
  label: "Etiqueta",
  address: "Dirección",
  creating_address_successful: "La dirección se creó correctamente",
  deposit_info: "Depósitos bancarios",
  deposit_info_details: "Información de depósito bancario",
  deposit_addresses_title: "Depósitos cripto",
  deposit_addresses: "Direcciones de depósito",
  available_deposit_addresses: "Direcciones de depósito disponibles para {{transactionNetwork}}",
  new_deposit_address: "Nueva dirección de depósito",
  initial: "Inicial",
  pending: "Pendiente",
  settled: "Liquidado",
  success: "Correcto",
  failure: "Fallido",
  partial: "Parcial",
  amlreview: "En revisión",
  filter_deposits: "Filtro de depósitos",
  filter_invoices: "Filtro de enlaces de pago",
  invoice_payments: "Pagos",
  amount_min: "Importe mín.",
  amount_max: "Importe máx.",
  min_eur_value: "Valor mín. en EUR",
  max_eur_value: "Valor máx. en EUR",
  currency: "Moneda",
  status: "Estado",
  deposit_id: "ID de depósito",
  transaction: "Transacción",
  transaction_network: "Red de la transacción",
  transaction_fee: "Comisión de transacción pagada por el pagador",
  next: "Siguiente",
  back: "Atrás",
  invoice_submitted_for_review: "Enlace de pago enviado para revisión del MLRO",
  invoice_payer_address: "Dirección de billetera cripto del pagador",
  invoice_payer_address_required: "Se requiere una dirección del pagador.",
  invoice_address_unsupported: "Dirección no reconocida o no compatible",
  invoice_payer_unknown: "No conozco la dirección cripto del pagador",
  invoice_supporting_documents: "Documentos de respaldo",
  invoice_compliance_documents: "Documentos de cumplimiento",
  invoice_additional_documents: "Documentos adicionales (opcional)",
  invoice_additional_comments: "Comentarios adicionales (opcional)",
  invoice_additional_comments_placeholder: "Cualquier contexto adicional para el revisor de cumplimiento (opcional)",
  invoice_document_not_applicable: "No aplica",
  invoice_compliance_documents_required: "Cada documento de cumplimiento debe subirse o marcarse como no aplicable",
  invoice_upload_documents: "Subir archivos",
  invoice_document_too_large: "{{filename}} pesa {{size}}: cada archivo debe pesar {{limit}} o menos",
  invoice_documents_too_many: "Puedes adjuntar un máximo de 10 archivos",
  invoice_document_uploading: "Subiendo…",
  invoice_documents_uploading: "Espera a que terminen de subirse los documentos",
  invoice_copy_from_previous: "Copiar de uno anterior",
  invoice_copy_title: "Copiar de un enlace de pago anterior",
  invoice_copy_search_placeholder: "Buscar por nombre",
  invoice_copy_note: "Elige un enlace de pago para rellenar este paso con sus datos: la dirección del pagador, los documentos de cumplimiento y los comentarios que enviaste con él. Los documentos no se vuelven a subir.",
  invoice_copy_empty: "Aún no tienes enlaces de pago enviados anteriormente para copiar",
  invoice_copy_no_matches: "Ningún enlace de pago coincide con esa búsqueda",
  invoice_copy_in_progress: "Copiando…",
  invoice_copy_documents_refused: "Estos documentos los subió otro usuario y deben adjuntarse de nuevo: {{filenames}}",
  invoice_discard_title: "¿Descartar este enlace de pago?",
  invoice_discard_message: "Todo lo que ingresaste aquí, incluidos los documentos subidos, se perderá.",
  creating: "Creando…",
  discard: "Descartar",
  keep_editing: "Seguir editando",
  form_has_errors: "Corrige los campos resaltados",
  description: "Descripción",
  details: "Detalles",
  deposit_details: "Detalles del depósito",
  asset: "Activo",
  create_deposit_address: "Crear nueva dirección de depósito",
  edit_deposit_address: "Editar dirección de depósito",
  generate_deposit_address: "Generar nueva dirección de depósito",
  payment_method: "Método de pago",
  label_name: "Nombre de la etiqueta",
  label_id: "ID de la etiqueta",
  copy_to_clipboard: "Copiar al portapapeles",
  copied: "Copiado",
  client_name: "Nombre del cliente",
  client_id: "ID del cliente",
  beneficiary_name: "Nombre del beneficiario",
  beneficiary_address: "Dirección del beneficiario",
  bank_name: "Nombre del banco",
  bank_address: "Dirección del banco",
  include_reference_code: "Incluye el siguiente código de referencia al enviarnos fondos",
  invalid_address: "Dirección de {{transactionNetwork}} no válida",
  invalid_address_eip55: "Dirección de {{transactionNetwork}} no válida (falló la validación EIP-55)",
  select_transaction_network: "Selecciona la red de la transacción",
  euro_value: "Valor en euros",
  euro_deposits: "Depósitos en euros",
  gbp_deposits: "Depósitos en GBP",
  send_euro_to_bank: "Envía todos los depósitos en euros a la siguiente cuenta bancaria",
  send_gbp_to_bank: "Envía todos los depósitos en GBP a la siguiente cuenta bancaria",
  error: "Error",
  error_requesting_data: "Se produjo un error al solicitar los datos",
  payout: "Desembolso",
  trade: "Operación",
  deposit: "Depósito",
  withdraw: "Retirar",
  filter_ledger: "Filtro del libro mayor",
  filter_users_list: "Filtro de la lista de usuarios",
  filter_mlro: "Filtro del informe MLRO",
  category: "Categoría",
  operation_id: "ID de operación",
  amount: "Importe",
  fees: "Comisiones",
  fee: "Comisión",
  balance_after: "Saldo posterior",
  logged_out: "Sesión cerrada",
  you_logged_out: "Has cerrado sesión",
  no_clients_exists: "No existen clientes para esta cuenta",
  clients_load_failed: "No se pudieron cargar tus clientes",
  sign_in_failed: "No se pudo completar tu inicio de sesión",
  try_again: "Intentar de nuevo",
  notifications: "Notificaciones",
  contact_to_create_clients: "Contáctanos para crear clientes en tu cuenta",
  sold: "vendiste",
  save: "Guardar",
  settings: "Configuración",
  updated_user_settings: "La configuración del usuario se guardó correctamente",
  users_list: "Lista de usuarios",
  user_id: "ID de usuario",
  is_admin: "Administrador",
  bought: "compraste",
  trade_successful: "Operación correcta",
  you_successfully: "Realizaste correctamente",
  for: "por",
  no_pair_configured: "No hay ningún par de activos configurado",
  contact_to_add_asset_pair: "Contacta con soporte para agregar un nuevo par de activos",
  withdrawal_successful: "Retiro correcto",
  successfully_posted_withdrawal: "Enviaste correctamente un retiro de",
  successfully_created_withdrawal_address: "Creaste una nueva dirección de retiro correctamente",
  successfully_updated_withdrawal_address: "Actualizaste la dirección de retiro correctamente",
  updating_address_successful: "La dirección se actualizó correctamente",
  successfully_deleted_withdrawal_address: "Eliminaste la dirección de retiro correctamente",
  deleting_address_successful: "La dirección se eliminó correctamente",
  withdrawals: "Retiros",
  withdrawal_addresses: "Direcciones de retiro",
  crypto_addresses: "Direcciones cripto",
  bank_addresses: "Cuentas bancarias",
  withdrawal_method: "Método de retiro",
  new_withdrawal_address: "Agregar nueva dirección de retiro",
  new_bank_address: "Agregar nueva cuenta bancaria",
  approve_to_make_withdrawal: "Debes agregar una dirección de retiro para esta moneda antes de poder enviar retiros",
  make_withdrawal: "Hacer retiro",
  min_deposit: "Depósito mínimo",
  min_deposit_amounts: "Importes mínimos de depósito",
  filter_withdrawals: "Filtro de retiros",
  filter_payouts: "Filtro de desembolsos",
  withdrawal_id: "ID de retiro",
  withdrawals_history: "Historial de retiros",
  payouts_history: "Historial de desembolsos",
  reference_id: "ID de referencia",
  payout_amount: "Importe del desembolso",
  source_amount: "Importe de origen",
  provide_valid_address: "Ingresa una dirección válida",
  provide_valid_iban: "Ingresa un número IBAN válido",
  provide_valid_bic: "Ingresa un código BIC válido",
  unique_label_coin: "Crea un nombre de etiqueta único para asignar a esta dirección de moneda",
  unique_label_bank: "Crea un nombre de etiqueta único para asignar a esta cuenta bancaria",
  iban_number: "IBAN/Número de cuenta",
  bic_code: "Código BIC",
  name_bank: "Nombre del banco",
  address_bank: "Dirección del banco",
  iban_description: "El IBAN/Número de cuenta de la cuenta bancaria",
  bic_description: "El número BIC/SWIFT del banco",
  bank_description: "El nombre del banco, no de la sucursal",
  bank_address_description: "La dirección del banco, no de la sucursal",
  name_beneficiary: "Nombre del beneficiario",
  beneficiary_name_description: "El nombre de la empresa que figura en la cuenta bancaria a la que deseas enviar los fondos. No puede ser una persona física; debe ser el nombre de una empresa",
  beneficiary_address_description: "El domicilio social de la empresa titular de esta cuenta bancaria",
  address_beneficiary: "Dirección del beneficiario",
  create_withdrawal_address: "Crear nueva dirección de retiro",
  create_bank_withdrawal_address: "Agregar nueva cuenta bancaria",
  delete_address_description: "Estás a punto de eliminar la dirección de retiro",
  deleting_withdrawal_address: "Eliminando dirección de retiro",
  delete_withdrawal_address: "Eliminar dirección de retiro",
  address_details: "Detalles de la dirección",
  update_withdrawal_address: "Actualizar dirección de retiro",
  update_address: "Actualizar dirección",
  pair: "Par",
  tenant_name: "Inquilino",
  delete_pair_question: "¿Quieres eliminar el par",
  deleting_trading_pair: "Eliminando par de trading",
  yes_delete_pair: "Sí, eliminar par",
  deleting_successful: "Eliminación correcta",
  successfully_deleted_pair: "Eliminaste el par correctamente",
  estimated_values_assets: "Valores estimados del activo",
  field_required: "Este campo es obligatorio",
  want_to_create_trade: "¿Quieres crear una nueva operación de {{type}} por {{amountSubmit}} {{asset}}?",
  new_trading_offer_exchange: "{{operation}} {{primaryAmount}} {{primaryAsset}} por {{secondaryAmount}} {{secondaryAsset}}",
  new_payout_offer_exchange: "Desembolso: {{payoutAmount}} {{payoutAsset}}",
  new_trading_offer_rate: "Tipo de cambio de esta oferta: {{rate}}",
  new_trading_offer_fees: "Comisiones: {{feeAmount}} {{feeAsset}}",
  new_trading_offer_no_fees: "El tipo de cambio ofrecido incluye todas las comisiones de transacción",
  new_payout_offer_fees: "Comisiones: {{totalFeesInSourceAsset}} {{sourceAsset}}",
  new_payout_offer_total_cost: "Costo total: {{totalCostInSourceAsset}} {{sourceAsset}}",
  posting_new_trade: "Enviando nueva operación",
  exchange_rate: "Tipo de cambio",
  trading_offer: "Oferta de operación",
  payout_offer: "Oferta de desembolso",
  payout_details: "Detalles del desembolso",
  requesting_new_trade: "Solicitando oferta de operación",
  requesting_new_payout: "Solicitando oferta de desembolso",
  yes_create_trade: "Sí, crear operación",
  number_at_min: "El número debe ser como mínimo",
  amount_buy_sell: "Importe a comprar/vender",
  amount_spend_receive: "Importe a gastar/recibir",
  spend: "Gastar",
  receive: "Recibir",
  buy_price: "Precio de compra",
  sell_price: "Precio de venta",
  balances: "Saldos",
  no_balances: "Sin saldos",
  copyright: "Copyright",
  all_rights_reserved: "Todos los derechos reservados",
  selected_client: "Cliente seleccionado",
  logout: "Cerrar sesión",
  dashboard: "Panel",
  select_client: "Seleccionar cliente",
  trading_panel: "Panel de trading",
  ledger: "Libro mayor",
  mlro: "Informe MLRO",
  email_invalid: "El correo electrónico no es válido",
  send_email: "Enviar correo",
  email: "Correo electrónico",
  removing_2fa_successful: "Autenticación de dos factores eliminada correctamente",
  value_invalid: "El valor no es válido",
  id_invalid: "El ID no es válido",
  operation_id_invalid: "El ID de operación no es válido",
  trade_id_invalid: "El ID de operación no es válido",
  withdrawal_id_invalid: "El ID de retiro no es válido",
  address_invalid: "La dirección no es válida",
  date_invalid: "La fecha no es válida",
  insufficient_funds: "Fondos insuficientes. Tienes {{amountToSpend}} {{spendCurrency}} para gastar",
  type_error: "El valor debe ser de tipo {{type}}",
  length_error: "El valor debe tener exactamente {{length}} caracteres",
  min_error: "El valor debe tener al menos {{min}} caracteres",
  max_error: "El valor no debe tener más de {{max}} caracteres",
  min_number_error: "El número debe ser como mínimo {{min}}",
  max_number_error: "El número debe ser como máximo {{max}}",
  less_number_error: "El número debe ser menor que {{max}}",
  should_be_more: "El valor debe ser mayor que {{min}}",
  export: "Exportar",
  panel: "Panel",
  change_language: "Cambiar idioma",
  approved: "Aprobado",
  field_digits_message: "El campo debe tener {{count}} decimales o menos",
  bank_withdrawal: "Retiro bancario",
  qr_code: "Código QR",
  sign_up: "Registrarse",
  client_info: "Información del cliente",
  current_fee: "Comisión actual",
  client_fees: "Comisiones del cliente",
  current_trade_volume: "Volumen de operaciones actual",
  tx_fee_schedule: "Tabla de comisiones",
  volume_needed_for_next_tier: "Volumen necesario para el siguiente nivel",
  client_api_keys: "Claves API del cliente",
  workflows: "Flujos de trabajo",
  external_id: "ID externo",
  no_options: "Sin opciones",
  nav_trading: "Trading",
  nav_balances: "Saldos",
  nav_deposits: "Depósitos",
  nav_deposit_addresses: "Direcciones de depósito",
  nav_withdrawals: "Retiros",
  nav_payouts: "Desembolsos",
  nav_payment_links: "Enlace de pago",
  nav_workflows: "Flujos de trabajo",
  nav_ledger: "Libro mayor",
  nav_client: "Información del cliente",
  theme: "Tema",
  dark_mode: "Modo oscuro",
  loading: "Cargando",
  view_as_banner: "Estás viendo el panel como {{email}}. Solo lectura: no se puede cambiar nada.",
  act_as_banner: "Estás actuando como {{email}}. Los cambios se registran como realizados por ti en su nombre.",
  view_as_return: "Volver a mi cuenta",
  view_as_failed: "No se pudo ver el panel como ese usuario: {{message}}",
  add_new_workflow: "Agregar nuevo flujo de trabajo",
  workflow: "Flujo de trabajo",
  enabled: "Habilitado",
  add_workflow: "Agregar flujo de trabajo",
  workflow_created: "Nuevo flujo de trabajo del cliente creado",
  workflow_deleted: "Flujo de trabajo eliminado",
  workflow_delete_confirm: "Este flujo de trabajo se eliminará.",
  no_workflows: "Sin flujos de trabajo.",
  are_you_sure: "¿Estás seguro?",
  asset_to_buy: "Activo a comprar",
  workflow_when: "Cuando",
  workflow_is_deposited: "se deposite,",
  workflow_convert_to: "convertirlo a",
  workflow_using_market_order: "mediante orden de mercado.",
  deposit_asset: "Activo de depósito",
  password: "Contraseña",
  sign_up_to: "Regístrate en {{brand}}",
  registration_success_message: "Ve a tu bandeja de entrada para confirmar tu correo electrónico",
  registration_error_title: "¡Se produjo un error!",
  please_try_again: "Inténtalo de nuevo",
  invitation_not_valid: "Este enlace de invitación no es válido",
  invitation_not_valid_message: "Pide a tu administrador que te envíe una nueva invitación.",
  invitation_revoked: "Esta invitación ha sido revocada",
  invitation_revoked_message: "Fue cancelada por un administrador. Pídele un nuevo enlace de invitación.",
  invitation_expired: "Esta invitación ha caducado",
  invitation_expired_message: "Los enlaces de invitación son válidos por un tiempo limitado. Pide uno nuevo a tu administrador.",
  invitation_used: "Esta invitación ya se ha utilizado",
  invitation_used_message: "Se creó una cuenta con este enlace. Intenta iniciar sesión.",
  invitation_check_failed: "No pudimos comprobar tu invitación",
  invitation_check_failed_message: "Puedes continuar: se comprobará cuando te registres.",
  already_have_account: "¿Ya tienes una cuenta?",
  login: "Iniciar sesión",
  password_should_contain: "La contraseña debe contener:",
  password_too_weak: "Demasiado débil",
  pwd_number: "Número",
  pwd_lowercase: "Letra minúscula",
  pwd_uppercase: "Letra mayúscula",
  pwd_special: "Carácter especial",
  pwd_min_length: "Al menos 8 caracteres",
  pwd_no_email: "Nada de tu dirección de correo electrónico",
  pwd_contains_email: "La contraseña no puede contener tu correo electrónico ni la parte anterior a la @",
  password_too_weak_error: "La contraseña es demasiado débil. Usa una más larga con más tipos de caracteres",
  pwd_too_common: "La contraseña es demasiado común. Elige una más difícil de adivinar",
  clear_filters: "Borrar filtros",
  all: "Todos",
  confirm: "Confirmar",
  create: "Crear",
  action: "Acción",
  download_pdf: "Descargar PDF",
  no_deposits: "Sin depósitos.",
  no_deposit_addresses: "Sin direcciones de depósito.",
  no_deposit_methods: "Sin métodos de depósito.",
  no_ledger_entries: "Sin asientos en el libro mayor.",
  all_operations_for_id: "Todas las operaciones del ID: {{id}}",
  current_balances: "Saldos actuales",
  account_value: "Valor de la cuenta",
  fiat_balances: "Saldos en fiat",
  coin_balances: "Saldos en monedas",
  client_legal_name: "Razón social",
  select_all: "Seleccionar todo",
  api_key_permissions: "Selecciona los permisos de la clave API:",
  add_ip_address: "Agregar dirección IP",
  ip_address: "Dirección IP",
  allowed_ip_addresses: "Direcciones IP permitidas",
  no_ip_addresses_yet: "Aún no hay direcciones IP.",
  ip_address_added: "Dirección IP agregada correctamente",
  generate_callback_secret_question: "¿Quieres generar un nuevo secreto de callback?",
  error_occured_title: "Se produjo un error",
  create_payout: "Crear desembolso",
  prepare_payout_offer: "Preparar una oferta de desembolso",
  payout_method: "Método de desembolso",
  source_asset: "Activo de origen",
  select_asset: "Seleccionar activo",
  charge_me_in: "Cobrarme en...",
  i_know_amount: "Conozco el importe en {{asset}}",
  callback_url_optional: "URL de callback (opcional)",
  resend_callback: "Reenviar callback",
  callback_resent: "Callback reenviado correctamente",
  payout_added: "Desembolso agregado correctamente",
  no_payouts: "Sin desembolsos.",
  remaining: "Restante",
  seconds: "segundos",
  include_tx_fee: "Incluir la comisión de transacción en el tipo de cambio",
  no_trades: "Sin operaciones.",
  no_withdrawals: "Sin retiros.",
  no_withdrawal_addresses: "Sin direcciones de retiro.",
  no_bank_accounts: "Sin cuentas bancarias.",
  no_api_keys: "Sin claves API.",
  payment_link_fees: "Comisiones del enlace de pago",
  payout_step_send_asset: "Selecciona el activo a enviar",
  payout_step_charge_asset: "Selecciona el activo en el que quieres que se te cobre",
  payout_step_amount: "Indica el importe",
  payout_step_address: "Indica la dirección y la información opcional",
  description_optional: "Descripción (opcional)",
  external_id_optional: "ID externo (opcional)",
  paid: "Pagado",
  amount_due: "Importe adeudado (incl. comisión de transacción)",
  outstanding: "Pendiente de pago",
  outstanding_note: "El pagador ha enviado menos del importe adeudado.",
  partly_paid: "Pagado parcialmente",
  unpaid: "Sin pagar",
  expired: "Caducado",
  rejected: "Rechazado",
  in_review: "En revisión",
  payment_in_review: "Pago en revisión",
  draft_rejected: "Borrador rechazado",
  created_at: "Creado el",
  expires_at: "Caduca el",
  url: "URL",
  locked_payment: "Pago bloqueado",
  declared_payer_addresses: "Direcciones del pagador declaradas",
  additional_comments: "Comentarios adicionales",
  no_payments_yet: "Aún no hay pagos.",
  none_declared: "Ninguna declarada",
  none_attached: "Ninguno adjunto",
  customer_support: "Atención al cliente",
  view_the_payment_link: "Ver el enlace de pago",
  create_payment_link: "Crear enlace de pago",
  edit_payment_link: "Editar enlace de pago",
  delete_payment_link: "Eliminar enlace de pago",
  payment_link_delete_confirm: "¿Seguro que quieres eliminar este enlace de pago?",
  draft: "Borrador",
  confirmed: "Confirmado",
  flagged_by_aml: "Marcado por AML",
  unknown_payer: "Pagador desconocido",
  draft_approved: "Borrador aprobado.",
  no_payment_links: "Sin enlaces de pago.",
  payment_link_number: "Enlace de pago n.º {{id}}",
  pending_payment_link_number: "Enlace de pago pendiente n.º {{id}}",
  contact_support_for_assistance: "Contacta con {{email}} para obtener más ayuda.",
  payment_link_added: "Enlace de pago agregado correctamente",
  payment_link_delete_body: "El enlace de pago dejará de aceptar pagos.",
  document_passport: "Pasaporte",
  document_purchase_agreement: "Contrato de compra firmado",
  document_proof_of_address: "Comprobante de domicilio",
  document_source_of_funds: "Origen de los fondos",
  impersonation_warning: "Has iniciado sesión como {{client}}. Cualquier acción que realices afectará a la cuenta de este cliente.",
  terms_greeting: "Estimado cliente:",
  terms_intro_updated: "Hemos actualizado nuestros Términos y condiciones para reflejar mejor nuestros servicios y ofrecerte mayor claridad.",
  terms_intro_review: "Revísalos a continuación. Para seguir usando nuestros servicios, confirma que aceptas los Términos y condiciones actualizados:",
  terms_questions: "Si tienes alguna pregunta, escríbenos a {{email}}",
};
